import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithAuth } from "~/ui-rtk/utils/base-query"

export const emptySplitApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    "Auth",
    "UserCompany",
    "Connectors",
    "CompanyConnectors",
    "ConnectionLinkCreated",
    "KeyEvents",
    "BudgetUpdateCadence",
    "CustomAttributionModels",
    "CustomAttributionWeights",
    "CustomAttributionMediaTargets",
    "CustomAttributionInitiativeTypes",
    "PaidMediaPlatforms",
    "Campaign",
    "AdSet",
    "Ad",
    "AdCreative",
    "AdCreativeAnalysis",
    "AdForgeDefaults",
    "BrandKit",
    "OverlayLayout",
    "Tag",
    "MediaTag",
    "TagCategory",
    "TagAssignment",
    "Assets",
    "AssetProductTags",
    "MegaFeedStructures",
    "PipelineProgress",
    "CompanyFinancials",
    "BudgetRecommenderRowSettings",
    "BudgetRecommenderHolds",
    "BudgetRecommenderBrandedSearch",
    "AudienceClassifications",
    "ApiKeys",
    "SavedReport",
    "CompanyCustomReport",
    "CompanyArtifact",
    "CompanyCustomMetric",
    "CompanyCustomMetricValues",
    "AgendaSlots",
    "JobSchedules",
    "AdsQaIgnoredAds",
    "AdsQaDoneAds",
    "CommentModerationSettings",
    "CommentDecisions",
    "CommentSummaries",
    "AdLaunchGoals",
    "TikTokAdvertiser",
    "Partnership",
    "MetaBrandCredential",
    "MetaAccountUser",
    "MetaAccountAssignment",
    "MetaAccess",
  ],
  endpoints: () => ({}),
})
